import { c as _c } from "react/compiler-runtime";
import IdentitySearch, { IdentitySearchSize } from "../input/identity/IdentitySearch";
import SelectGroupModalSearchName from "./SelectGroupModalSearchName";
export default function SelectGroupModalSearch(t0) {
  const $ = _c(10);
  const {
    groupName,
    groupUser,
    onUserSelect,
    onFilterNameSearch,
    showIdentitySearch: t1
  } = t0;
  const showIdentitySearch = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== groupUser || $[1] !== onUserSelect || $[2] !== showIdentitySearch) {
    t2 = showIdentitySearch && <IdentitySearch size={IdentitySearchSize.SM} identity={groupUser} setIdentity={onUserSelect} />;
    $[0] = groupUser;
    $[1] = onUserSelect;
    $[2] = showIdentitySearch;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== groupName || $[5] !== onFilterNameSearch) {
    t3 = <SelectGroupModalSearchName filterName={groupName} setFilterName={onFilterNameSearch} />;
    $[4] = groupName;
    $[5] = onFilterNameSearch;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="tw-col-span-full tw-mt-4 tw-px-4"><div className="tw-grid tw-grid-cols-1 tw-gap-y-3">{t2}{t3}</div></div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}